var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDragRows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 24,
    viewBox: "0 0 64 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 24,
    rx: 1.5,
    fill: "#B7F84D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 23,
    rx: 1,
    stroke: "white",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 7C6 7.55228 5.55228 8 5 8C4.44772 8 4 7.55228 4 7C4 6.44772 4.44772 6 5 6C5.55228 6 6 6.44772 6 7Z",
    fill: "#121419"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12C6 12.5523 5.55228 13 5 13C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11C5.55228 11 6 11.4477 6 12Z",
    fill: "#121419"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17C6 17.5523 5.55228 18 5 18C4.44772 18 4 17.5523 4 17C4 16.4477 4.44772 16 5 16C5.55228 16 6 16.4477 6 17Z",
    fill: "#121419"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7C11 7.55228 10.5523 8 10 8C9.44772 8 9 7.55228 9 7C9 6.44772 9.44772 6 10 6C10.5523 6 11 6.44772 11 7Z",
    fill: "#121419"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12C11 12.5523 10.5523 13 10 13C9.44772 13 9 12.5523 9 12C9 11.4477 9.44772 11 10 11C10.5523 11 11 11.4477 11 12Z",
    fill: "#121419"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17C11 17.5523 10.5523 18 10 18C9.44772 18 9 17.5523 9 17C9 16.4477 9.44772 16 10 16C10.5523 16 11 16.4477 11 17Z",
    fill: "#121419"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55 7C55 7.55228 54.5523 8 54 8C53.4477 8 53 7.55228 53 7C53 6.44772 53.4477 6 54 6C54.5523 6 55 6.44772 55 7Z",
    fill: "#B7F84D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55 12C55 12.5523 54.5523 13 54 13C53.4477 13 53 12.5523 53 12C53 11.4477 53.4477 11 54 11C54.5523 11 55 11.4477 55 12Z",
    fill: "#B7F84D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55 17C55 17.5523 54.5523 18 54 18C53.4477 18 53 17.5523 53 17C53 16.4477 53.4477 16 54 16C54.5523 16 55 16.4477 55 17Z",
    fill: "#B7F84D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M60 7C60 7.55228 59.5523 8 59 8C58.4477 8 58 7.55228 58 7C58 6.44772 58.4477 6 59 6C59.5523 6 60 6.44772 60 7Z",
    fill: "#B7F84D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M60 12C60 12.5523 59.5523 13 59 13C58.4477 13 58 12.5523 58 12C58 11.4477 58.4477 11 59 11C59.5523 11 60 11.4477 60 12Z",
    fill: "#B7F84D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60 17C60 17.5523 59.5523 18 59 18C58.4477 18 58 17.5523 58 17C58 16.4477 58.4477 16 59 16C59.5523 16 60 16.4477 60 17Z",
    fill: "#B7F84D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDragRows);
export default __webpack_public_path__ + "static/media/icon-drag-rows.138409056b6bfb60f09321430c095774.svg";
export { ForwardRef as ReactComponent };